import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-product-subtotal-cell',
  templateUrl: './product-subtotal-cell.component.html',
  styleUrls: ['./product-subtotal-cell.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductSubtotalCellComponent {

}
